import React, { useState, useEffect } from "react";
import { Image } from "antd";
import { routes } from "../../Routes";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { store } from "../../Redux/store";
import { Menu, X } from "lucide-react";
import Button from "../../components/ui/button";
import LanguageSwitcher from "../../components/language-switcher";
import { getUTMs } from "../../Utils/utm";
import { getUserOnboarding } from "../../API  Functions/DashboardFunctions";

const Navbar = () => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [imageScale, setImageScale] = useState(0.7);
  const [scrollY, setScrollY] = useState(0);
  const { t, i18n } = useTranslation();

  const [modalTitle, setModalTitle] = useState(t("Talk to Sales"));
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const { login } = store.getState();
  const user_id = login.user;
  const is_retailer = login.user?.result?.is_retailer;
  const company_id = login.user?.result?.company_id;
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);
  const [onboardingDone, setOnboardingDone] = useState(null); // null = loading
  const [utms, setUtms] = useState({});

  useEffect(() => {
    const data = getUTMs();
    Object.keys(data).forEach((key) => data[key]);
    setUtms(data);
  }, []);

  useEffect(() => {
    const checkScreen = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkScreen();
    window.addEventListener("resize", checkScreen);

    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  useEffect(() => {
    const fetchOnboarding = async () => {
      if (company_id) {
        const result = await CheckUserOnboarding(company_id);
        setOnboardingDone(result);
      }
    };
    if (company_id) {
      fetchOnboarding();
    }
  }, [company_id]);

  const CheckUserOnboarding = async (id) => {
    try {
      const res1 = await getUserOnboarding(id);

      if (res1?.result[0]?.status_code === 200) {
        let keys = res1?.result[0];

        return (
          keys?.update_inventory &&
          keys?.cashier_setup &&
          keys?.weighing_scale &&
          keys?.add_user &&
          keys?.delivery_company
        );
      }
      return false;
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      return false;
    }
  };

  return (
    <>
      <header className="fixed top-0 left-0 right-0 w-full bg-background/95 backdrop-blur-sm border-b border-border z-50">
        {/* Added standard max-width configuration to lock boundaries during zoom */}
        <div className="mx-auto w-full max-w-[1280px] px-4">
          <div className="flex items-center justify-between h-16 w-full">
            {/* FIX 1: Removed `mx-auto` and center utilities from the outer logo wrapper to keep it pinned left */}
            <div className="flex items-center flex-shrink-0 ">
              <a href="/">
                <Image
                  src={require("../../assets/Logo/hisabakLogo.png")}
                  alt="myGINNE logo"
                  width={140}
                  height={38}
                  preview={false}
                />
                {/* <Image
                  src="https://hisabak.com/static/media/hisabakLogo.35953b144495459dcc84.png"
                  alt="myGINNE logo"
                  width={140}
                  height={40}
                  preview={false}
                  className="object-contain"
                /> */}
              </a>
            </div>
            <div className="flex flex-row items-center justify-center md:p-[3rem]">
              {/* Navigation Link Group */}
              <nav
                className={`hidden md:flex items-center mx-4 me-12 ${i18n.language === "ar" ? "gap-10" : "gap-8"
                  }`}
              >
                <a
                  href="/#features"
                  className="text-foreground/80 hover:text-primary transition-colors whitespace-nowrap"
                >
                  {t("Features")}
                </a>
                <a
                  href="/#how-it-works"
                  className="text-foreground/80 hover:text-primary transition-colors whitespace-nowrap"
                >
                  {t("How it Works")}
                </a>
                <a
                  href="/#testimonials"
                  className="text-foreground/80 hover:text-primary transition-colors whitespace-nowrap"
                >
                  {t("Testimonials")}
                </a>
                {/* <a
                href="/#pricing"
                className="text-left px-4 py-2 text-foreground hover:text-primary"
              >
                {t("Pricing")}
              </a> */}
                <a
                  href="/aboutus"
                  className="text-foreground/80 hover:text-primary transition-colors"
                >
                  {t("About Us")}
                </a>
                <a
                  href="/#faqs"
                  className="text-foreground/80 hover:text-primary transition-colors whitespace-nowrap"
                >
                  {t("FAQs")}
                </a>
              </nav>

              {/* FIX 2: Added flex-shrink-0 to the actions layout wrapper to hold alignment right */}
              <div className="flex items-center space-x-4 flex-shrink-0 justify-end">
                <LanguageSwitcher loading={loading} setLoading={setLoading} />
                {user_id && navigate(routes.dashboard)}
                <Button
                  className="hidden md:inline-flex bg-primary hover:bg-primary-dark text-primary-foreground whitespace-nowrap"
                  onClick={() => navigate(routes.login)}
                >
                  {t("Sign Up / Login")}
                </Button>

                {/* Mobile Menu Button */}
                <button
                  className="md:hidden p-2"
                  onClick={() => setIsMenuOpen(!isMenuOpen)}
                >
                  {isMenuOpen ? (
                    <X className="w-6 h-6" />
                  ) : (
                    <Menu className="w-6 h-6" />
                  )}
                </button>
              </div>
            </div>
          </div>

          {/* Mobile Menu */}
          {isMenuOpen && (
            <div className="md:hidden py-4 border-t border-border bg-background">
              <nav className="flex flex-col space-y-2">
                <a
                  href="/#features"
                  className="text-left px-4 py-2 text-foreground hover:text-primary"
                >
                  {t("Features")}
                </a>

                <a
                  href="/#how-it-works"
                  className="text-left px-4 py-2 text-foreground hover:text-primary"
                >
                  {t("How it Works")}
                </a>

                <a
                  href="/#testimonials"
                  className="text-left px-4 py-2 text-foreground hover:text-primary"
                >
                  {t("Testimonials")}
                </a>
                {/* <a
                  href="/#pricing"
                  className="text-left px-4 py-2 text-foreground hover:text-primary"
                >
                  {t("Pricing")}
                </a> */}
                <a
                  href="/aboutus"
                  className="text-left px-4 py-2 text-foreground hover:text-primary"
                >
                  {t("About Us")}
                </a>
                <a
                  href="/#faqs"
                  className="text-left px-4 py-2 text-foreground hover:text-primary"
                >
                  {t("FAQs")}
                </a>
                <div className="px-4 py-2 space-y-2">
                  {user_id && navigate(routes.dashboard)}
                  <Button
                    className="w-full bg-primary hover:bg-primary-dark text-primary-foreground"
                    onClick={() => navigate(routes.login)}
                  >
                    {t("Sign Up / Login")}
                  </Button>
                </div>
              </nav>
            </div>
          )}
        </div>
      </header>
    </>
  );
};
export default Navbar;
